import React from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import Layout from '../../Checkout/Layout/layout';
import { CheckoutProvider, useCheckoutContext } from "../../../context/experienceCheckoutContext";
import Loader from '../../../components/Loader/Loader';
import Billing from './Billing';
import Payments from './Payments';
import BookingQuestions from './BookingQuestions/BookingQuestions'
import Enjoy from './Enjoy';
import PassengersAndBookingQuestions from './PassengersAndBookingQuestions';
// import Passengers from './Passengers';

const CheckoutComponent = ({ children }: { children: React.ReactNode}) => {
  const { order, loading, error } = useCheckoutContext();
  const navigate = useNavigate();
  const location = useLocation();

  if (error && error.message === 'Order not found') {
    // Extract the experience slug from the current path
    // Example path: /experiences/archeological-crypt-visit-with-an-archeologist-and-river-cruise-68b8903a/checkout/payments
    const match = location.pathname.match(/^\/experiences\/([^/]+)/);
    const experienceSlug = match ? match[1] : '';
    if (experienceSlug) {
      navigate(`/experiences/${experienceSlug}`);
    } else {
      navigate('/');
    }
  }

  if (loading || !order) {
    return <Loader />;
  }

  return children;
};

const Checkout = () => {
  return (
    <CheckoutProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route path="passengers" element={
            <CheckoutComponent>
              {/* <Passengers /> */}
              <PassengersAndBookingQuestions />
            </CheckoutComponent>
          } />
          <Route path="booking-questions" element={<BookingQuestions />} />
          <Route path="billing" element={
            <CheckoutComponent>
              <Billing />
            </CheckoutComponent>
          } />
          <Route path="payments" element={
            <Payments />
          } />
          {/* Does not receive CheckoutComponent since that context get's lost while redirecting back from MercadoPago */}
          <Route path="enjoy" element={ <Enjoy />} />
          <Route path="*" element={<Navigate to="/home" />} />
        </Route>
      </Routes>
    </CheckoutProvider>
  );
};

export default Checkout;
